import { PromoHeadingColor } from './PromoHeadingColor.type'

export const headingColorMap: Record<string, string> = {
  [PromoHeadingColor.BERRY]: 'u-textColorBerry',
  [PromoHeadingColor.DARK_MINT]: 'u-textColorDarkMint',
  [PromoHeadingColor.MIDNIGHT_BLUE]: 'u-textColorMidnightBlue',
  [PromoHeadingColor.PURPLE]: 'u-textColorPurple',
  [PromoHeadingColor.NEUTRAL]: 'u-textColorNeutral'
}
